var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPinIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5537_147316",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 1,
    width: 10,
    height: 14
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.2002 1.67749H12.8172V14.3525H3.2002V1.67749Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5537_147316)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00869 1.67749C9.28372 1.67749 10.5065 2.18399 11.4081 3.08557C12.3097 3.98716 12.8162 5.20996 12.8162 6.48499C12.8162 6.48499 12.9997 11.118 8.38469 14.2375C8.27355 14.3123 8.14264 14.3522 8.00869 14.3522C7.87474 14.3522 7.74383 14.3123 7.63269 14.2375C3.01769 11.118 3.20119 6.48499 3.20119 6.48499C3.20119 5.20996 3.70769 3.98716 4.60927 3.08557C5.51086 2.18399 6.73366 1.67749 8.00869 1.67749ZM7.93669 9.17249C8.78538 9.17249 9.59932 8.83535 10.1994 8.23523C10.7995 7.63512 11.1367 6.82118 11.1367 5.97249C11.1367 5.1238 10.7995 4.30986 10.1994 3.70975C9.59932 3.10963 8.78538 2.77249 7.93669 2.77249C7.088 2.77249 6.27407 3.10963 5.67395 3.70975C5.07383 4.30986 4.73669 5.1238 4.73669 5.97249C4.73669 6.82118 5.07383 7.63512 5.67395 8.23523C6.27407 8.83535 7.088 9.17249 7.93669 9.17249Z",
    fill: "#00BCF1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0801 6.5725C11.168 6.10993 11.1527 5.63366 11.0354 5.17767C10.918 4.72167 10.7015 4.29719 10.4012 3.9345C10.101 3.57181 9.72437 3.27986 9.2983 3.07945C8.87223 2.87905 8.40718 2.77515 7.93633 2.77515C7.46548 2.77515 7.00043 2.87905 6.57436 3.07945C6.14828 3.27986 5.77168 3.57181 5.47142 3.9345C5.17116 4.29719 4.95463 4.72167 4.83729 5.17767C4.71995 5.63366 4.70468 6.10993 4.79258 6.5725C4.93273 5.84144 5.32329 5.18207 5.89707 4.70785C6.47084 4.23362 7.19195 3.9742 7.93633 3.9742C8.68071 3.9742 9.40182 4.23362 9.97559 4.70785C10.5494 5.18207 10.9399 5.84144 11.0801 6.5725Z",
    fill: "#007EB1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7967 6.06201C12.6907 7.36451 12.0567 10.804 8.38471 13.2855C8.2736 13.3604 8.14268 13.4003 8.00871 13.4003C7.87475 13.4003 7.74383 13.3604 7.63271 13.2855C3.96121 10.804 3.32671 7.36501 3.22021 6.06201C3.2074 6.20265 3.20073 6.34379 3.20021 6.48501C3.20021 6.48501 3.01671 11.118 7.63221 14.237C7.74333 14.3119 7.87425 14.3518 8.00821 14.3518C8.14218 14.3518 8.2731 14.3119 8.38421 14.237C12.9992 11.118 12.8157 6.48501 12.8157 6.48501C12.8157 6.34251 12.8082 6.20151 12.7957 6.06201",
    fill: "#007DAC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinIcon);
export default __webpack_public_path__ + "static/media/pin-icon.b30cadfd20082140bf3247191f40e15c.svg";
export { ForwardRef as ReactComponent };